(() => {
  const init = () => {
    document.querySelectorAll('.km-pricing-grid').forEach(grid => {
      if (grid.dataset.averageRatingsInitialized) return;
      grid.dataset.averageRatingsInitialized = 'true';
      const update = () => {
        grid.querySelectorAll('.group-stars[aria-label]').forEach(stars => {
          const match = stars.getAttribute('aria-label').match(/^([0-9]+(?:\.[0-9]+)?)-star/);
          if (!match) return;
          const average = Number(match[1]);
          if (average < 0 || average > 5) return;
          let label = stars.querySelector('.km-rating-average');
          if (!label) {
            label = document.createElement('span');
            label.className = 'km-rating-average';
            label.setAttribute('aria-hidden', 'true');
            stars.append(label);
          }
          const value = average.toFixed(1);
          if (label.textContent !== value) label.textContent = value;
        });
      };
      new MutationObserver(update).observe(grid, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label']});
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
